export default function T(s, ...args) {
  return args.reduce((a, c, index) => a.replace(`{${index}}`, c), s);
}
